import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import * as TegoServerActionTypes from './actionTypes';
import { showErrorNotification } from '../notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
MiddlewareRegistry.register(store => next => (action) => {
    const result = next(action);
    switch (action.type) {
        case TegoServerActionTypes.INIT_CONFIG_FAILURE: {
            store.dispatch(showErrorNotification({
                title: 'tego no configurado',
                description: "Caracteristicas de TEGO habilitadas.",
                hideErrorSupportLink: true,
            }, NOTIFICATION_TIMEOUT_TYPE.LONG));
        }
    }
    return result;
});
